import { Link } from "react-router-dom";
import { Crown, ShieldAlert, Flame, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";

export const EliteBatchSpotlight = () => (
  <section id="elite-batch" className="py-24 sm:py-32 scroll-mt-16 bg-[#050505] relative overflow-hidden" data-testid="elite-spotlight-section">
    <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "radial-gradient(circle at 25% 70%, #D4AF37 0%, transparent 55%)" }} />
    <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
      <Reveal>
        <p className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37] font-bold flex items-center gap-2">
          <Crown size={12} /> Invitation Only · Zero Cost
        </p>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-4 leading-[1.05] max-w-3xl">
          The <span className="text-[#D4AF37]">Elite Batch.</span>
        </h2>
        <p className="mt-3 font-heading text-sm sm:text-base uppercase tracking-[0.25em] text-[#D4AF37]">
          The best of the best in their age groups.
        </p>
      </Reveal>

      <div className="mt-10 grid lg:grid-cols-[1.2fr_1fr] gap-10">
        <Reveal delay={0.1}>
          <p className="text-white/75 text-[15px] leading-relaxed">
            The Elite Batch is Zavi's zero-cost, invitation-only environment for the top talents in each age group. Selection is earned strictly on merit — either through scouting, performance trials, or by breaking through from within our paid Foundation, Development or Performance programs.
          </p>
          <p className="mt-4 text-white/75 text-[15px] leading-relaxed">
            We don't just take money. <span className="text-white font-semibold">When a player shows genuine promise, we give back</span> — by offering full-standard training environment, competitive match exposure, direct scouting attention and mentorship, entirely free of cost. If they meet the standard, the standard opens up to them.
          </p>
          <p className="mt-4 text-white/60 text-sm leading-relaxed border-l-2 border-[#D4AF37]/40 pl-4 italic">
            Access is granted only through scouting, performance trials, or direct recommendation by the coaching staff. Zero tolerance for complacency — players who don't maintain the required intensity, respect the environment, or bring the work ethic are removed.
          </p>
          <Link to="/elite" data-testid="elite-explore"
            className="mt-7 inline-flex items-center gap-2 bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-xs px-5 py-3 hover:bg-[#F3D059] transition-colors duration-200 gold-glow">
            Explore The Elite Batch <ArrowRight size={13} />
          </Link>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="space-y-3">
            {[
              { icon: Crown, title: "Zero-Cost Meritocracy", text: "Training completely free of cost. Elite development driven by raw talent, hunger and capability — not financial background." },
              { icon: Flame, title: "High-Intensity Sparring", text: "Training alongside the absolute best peers so every minute on the pitch pushes players to raise their ceiling." },
              { icon: ShieldAlert, title: "The Accountability Code", text: "Zero tolerance for complacency. Standards are non-negotiable — earn your spot, keep your spot." },
            ].map((c, i) => (
              <div key={c.title} className="border border-white/10 bg-black p-5 hover:border-[#D4AF37]/40 transition-colors duration-300" data-testid={`elite-card-${i}`}>
                <div className="flex items-center gap-3">
                  <c.icon size={18} className="text-[#D4AF37] shrink-0" />
                  <p className="font-heading text-base font-black uppercase tracking-tight">{c.title}</p>
                </div>
                <p className="text-white/55 text-xs mt-2 leading-relaxed">{c.text}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
